import { useTranslation } from "react-i18next";
import React, { Fragment, useState } from "react";
import {
  AppBar,
  Button,
  Box,
  Paper,
  Toolbar,
  Typography,
  ListItemButton,
} from "@mui/material";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import { useAuth } from "./context/auth-context";
import apiRequest from "./functions/api";
import { useSessionStorage } from "./utils/hooks";
import { useMessage } from "./context/message-context";
import { LOCAL_STORAGE_KEY } from "./constants/localStorage";
import MessageBox from "./components/shared/components/MessageBox";
function VerifyAccount() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [accessToken, setAccessToken] = useSessionStorage(
    LOCAL_STORAGE_KEY.accessToken
  );
  const { showErrorMessage } = useMessage();
  const [newUserName, setNewUserName] = useState("");
  const [newUserId, setNewUserId] = useState("");
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const handleUserSelect = (newusertmp) => {
    setNewUserName(newusertmp.name);
    setNewUserId(newusertmp.id);
    openMessageBox();
  };
  const openMessageBox = () => {
    setMessageBoxOpen(true);
  };
  const closeMessageBox = () => {
    setMessageBoxOpen(false);
  };
  function messageBoxResult(r) {
    if (r === "YES") {
      switchUser();
    }
    closeMessageBox();
  }
  const switchUser = () => {
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      userid: newUserId,
    };
    apiRequest("POST", "user-switch", payload, headers, switchUserCb);
  };
  const switchUserCb = (response) => {
    if (response.status === 200) {
      setAccessToken(response.data.user.token);
      window.location.reload();
    } else {
      if (response.data) {
        showErrorMessage(response.data.message);
      }
    }
  };
  const displayUsers = user.verifyUsers.map((selectedUser, count) => {
    return (
      <ListItemButton
        divider
        key={"v" + count.toString()}
        onClick={() => handleUserSelect(selectedUser)}
      >
        <ListItemText primary={selectedUser.name} secondary={selectedUser.id} />
      </ListItemButton>
    );
  });

  return (
    <Fragment>
      <Box p={1}>
        <Typography variant="h4" color="primary">
          {t("Prüferzugang")}
        </Typography>
      </Box>
      <Box p={1}>
        <Typography variant="body1">
          {t("Folgende Zugänge müssen geprüft werden:")}
        </Typography>
      </Box>
      <Box p={1}>
        <List>{displayUsers}</List>
      </Box>
      <AppBar
        position="fixed"
        color="transparent"
        style={{ top: "auto", bottom: 0 }}
      >
        <Toolbar>
          <div style={{ flexGrow: 1 }}></div>
          <Button
            edge="end"
            color="primary"
            onClick={() => window.location.reload()}
          >
            {t("Weiter ohne Prüfung")}
          </Button>
          <div />
        </Toolbar>
      </AppBar>
      <MessageBox
        title={t("Hinweis")}
        text={"Wollen Sie User " + newUserName + " jetzt prüfen?"}
        buttons="YESNO"
        onClose={closeMessageBox}
        open={messageBoxOpen}
        handleResponse={messageBoxResult}
      />
    </Fragment>
  );
}
export default VerifyAccount;
